import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router';

import styles from './iconFeatureCard.scss';

import bootstrap from '@src/css/bootstrap.scss';


/**
 * IconFeatureCard - single button promo card with Featured image
 * @param {object} icon Icon image source and alt
 * @param {string} title Title of Promo card
 * @param {string} subtitle Subtitle or description
 * @param {object} button Button text and link
 */

export const IconFeatureCard = (props) => {
    const {
        icon,
        title,
        subtitle,
        button,
    } = props;

    const cardImageClassNames = classNames({
        [styles.iconCardImage]: true,
        'video-camera': title === 'Reimagine Foremost Virtual Event',
    });

    let target = '_self';
    if (button.link.search(/^https?:\/\//) !== -1) {
        target = '_blank';
    }

    return (
        <Card className="icon-feature-card">
            <Card.Body className="text-center">
                <div className={cardImageClassNames}>
                    <img
                        src={icon.source}
                        alt={icon.alt}
                    />
                </div>
                <h5 className={`card-title pt-3 pb-3 ${styles.iconCard_title}`}>
                    {title}
                </h5>
                <p className={`${bootstrap['card-text']} ${styles.iconCard_text}`}>
                    {subtitle}
                </p>
            </Card.Body>
            <Card.Footer className="border-0 rounded-0 pb-3 text-center">
                <Link
                    to={button.link}
                    className="btn btn-primary"
                    target={target}
                >
                    {button.text}
                </Link>
            </Card.Footer>
        </Card>
    );
};

IconFeatureCard.propTypes = {
    icon: PropTypes.shape({
        alt: PropTypes.string,
        source: PropTypes.string,
    }),
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    button: PropTypes.exact({
        text: PropTypes.string,
        link: PropTypes.string,
    }).isRequired,
};

export default IconFeatureCard;
